// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-4ae7f0","sapcnqr-badge--muted":"sapcnqr-badge--muted-b3ed5e"};